export default "__VITE_ASSET__8fa9d327__"